import { createAction, props, union } from '@ngrx/store';

import { TimetableStatus, StatusState } from '../../interfaces/index';

export const setStatus = createAction('[Timetable] setStatus', props<{ status: TimetableStatus }>());
export const setError = createAction('[Timetable] setError', props<{ error: StatusState['error'] }>());

const all = union({
  setStatus,
  setError,
});

export type StatusActionsUnion = typeof all;
